var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMain = function SvgMain(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4005 1.16267L13.0469 0.809097L13.4005 1.16267C13.8286 0.734564 14.395 0.5 15.0002 0.5C15.6053 0.5 16.1717 0.734574 16.5996 1.16259L16.5997 1.16268L28.8335 13.3948C28.8367 13.3981 28.8407 13.4022 28.8454 13.4068C29.7203 14.2888 29.7182 15.72 28.8391 16.5993C28.4107 17.0276 27.8443 17.2621 27.2395 17.2621H26.7872H26.2872V17.7621V26.7677C26.2872 28.2738 25.061 29.5 23.5544 29.5H18.7661H11.234H6.44577C4.93933 29.5 3.71294 28.2738 3.71294 26.7677V17.7621V17.2621H3.21294H2.72537C2.71285 17.2621 2.70054 17.2615 2.68815 17.2604L2.6749 17.2591L2.66159 17.2585C2.09292 17.2339 1.56324 17.0015 1.161 16.5991L1.16091 16.599C0.281215 15.7194 0.279597 14.2873 1.15666 13.4052L1.15678 13.4053L1.16414 13.3975L1.1644 13.3973L1.16801 13.3937L13.4005 1.16267Z",
    stroke: "current",
    fill: "current"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/main.a2f181af.svg";
export { ForwardRef as ReactComponent };